export default __webpack_public_path__ + "static/media/OWL.6bf8ac51.wav";